var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggleOuter",class:{ toggleSwitching: _vm.switching, toggleDisabled: _vm.disabled, toggleOn: _vm.active},on:{"click":_vm.toggleSwitch}},[_c('div',{staticClass:"toggleInner"})])}
var staticRenderFns = []

export { render, staticRenderFns }